// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"d52ddbe6","314":"607938cf","352":"9208b99a","542":"a05215ec","947":"b0cb1fa8"}[chunkId] + ".chunk.js";
};